export default __webpack_public_path__ + "static/media/materialui.c0958f97.svg";